'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./PlanOption.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanOption = function PlanOption(_ref) {
    var className = _ref.className,
        children = _ref.children;
    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('PlanOption', className) },
        children
    );
};

PlanOption.propTypes = {
    className: _propTypes2.default.string,
    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array])
};

exports.default = PlanOption;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/plan/upgrade/PlanOption.js
// module id = 2075
// module chunks = 0